import type { AppContext } from "@/types/scheduling";
import { getParams } from "@/utils/app";

import { communicationStyles, nutritionAreas, paymentMethods, usaStates } from "@/utils/constants";
import { produce } from "immer";
import { objectValueMatch } from "shared/classes/utils";
import { insuranceList } from "shared/constants";

export const handleGetURLParams = <T extends AppContext>(context: T) => {
  const params = getParams();
  console.debug("params found", params);
  const newContext = produce(context, (draft) => {
    if (params.expertise) {
      draft.result.nutrition_area.value =
        objectValueMatch(params.expertise, nutritionAreas, "value", "contains") || "General Health";
      draft.result.nutrition_area.label = objectValueMatch(params.expertise, nutritionAreas) || "Select nutrition area";
      draft.result.nutrition_area.key = "nutrition_area";
    }
    if (params.nutrition_area) {
      draft.result.nutrition_area.value =
        objectValueMatch(params.nutrition_area, nutritionAreas, "value") || "General Health";
      draft.result.nutrition_area.label =
        objectValueMatch(params.nutrition_area, nutritionAreas) || "Select nutrition area";
      draft.result.nutrition_area.key = "nutrition_area";
    }
    if (params.state) {
      draft.result.state.value = objectValueMatch(params.state, usaStates, "value") || "error";
      draft.result.state.label = objectValueMatch(params.state, usaStates) || "Select your state";
      draft.result.state.key = "state";
    }
    if (params.communication_style) {
      draft.result.communication_style.value =
        objectValueMatch(params.communication_style, communicationStyles, "value") || "error";
      draft.result.communication_style.label =
        objectValueMatch(params.communication_style, communicationStyles) || "Select communication style";
      draft.result.communication_style.key = "communication_style";
    }
    if (params.payment_method) {
      draft.result.payment_method.value = objectValueMatch(params.payment_method, paymentMethods, "value") || "error";
      draft.result.payment_method.label =
        objectValueMatch(params.payment_method, paymentMethods) || "Select your payment method";
      draft.result.payment_method.key = "payment_method";
    }
    if (params.insurance_provider) {
      draft.result.insurance_provider = {
        value: objectValueMatch(params.insurance_provider, insuranceList, "value") || "error",
        label: objectValueMatch(params.insurance_provider, insuranceList) || "Select your insurance",
        key: "insurance_provider",
      };
    }
    if (params.insurance_provider_other) {
      draft.result.insurance_provider_other = params.insurance_provider_other;
    }
    if (params.lead_name) {
      draft.result.lead_name = params.lead_name;
    }
    if (params.lead_email) {
      draft.result.lead_email = params.lead_email;
    }
    if (params.lead_phone_number) {
      draft.result.lead_phone_number = params.lead_phone_number;
    }
    if (params.diabetes_insulin_pump) {
      draft.result.diabetes_insulin_pump = params.diabetes_insulin_pump;
    }
    if (params.provider_id) {
      draft.provider_id = params.provider_id;
    }
    if (params.plan_id) {
      draft.plan_id = params.plan_id;
    }
    if (params.op_mode) {
      draft.internal = {
        op_mode: params.op_mode,
      };
    }
    draft.internal_completion.used_only_quiz_params = params.used_only_quiz_params;
    draft.internal_completion.used_only_url_params = params.used_only_url_params;
  });
  return newContext;
};
